import React from 'react';

const About = () => {
    return (
        <div className="container">
          <h1 className="text-center mt-3">About us</h1>
          <hr className="w-25 m-auto" />
            <div className="row mt-5">
           <div class=" card mb-3 col-md-6" >
  <div class="row g-0">
    <div class="col-md-4">
      <img src="https://img.freepik.com/free-photo/handsome-confident-smiling-man-with-hands-crossed-chest_176420-18743.jpg?size=626&ext=jpg" class="img-fluid rounded-start" alt="..."/>
    </div>
    <div class="col-md-8">
      <div class="card-body">
        <h5 class="card-title">Joe L. Shannon</h5>
        <p class="card-text">Considering a career in the trucking industry? Or are you a transportation company looking for trained drivers? Shelly Truck Driving School in York, PA provides 21st century training to future truck drivers.</p>
        <div className="p-2">
          <i class="bi bi-facebook p-2 fs-5"></i>
          <i class="bi bi-whatsapp p-2 fs-5"></i>
          <i class="bi bi-linkedin p-2 fs-5"></i>
          <i class="bi bi-youtube p-2 fs-5" ></i>
          </div>
      </div>
    </div>
  </div>
</div>

<div class="card mb-3 col-md-6" >
  <div class="row g-0">
    <div class="col-md-4">
      <img src="https://media.istockphoto.com/photos/african-mature-man-with-spectacles-picture-id1152603187?k=20&m=1152603187&s=612x612&w=0&h=GFzEtU3SUuueO3bqgM3GbQ8GTehFBM-V4CRPSbreims=" class="img-fluid rounded-start" alt="..."/>
    </div>
    <div class="col-md-8">
      <div class="card-body">
        <h5 class="card-title">Lonnie L. Bertram</h5>
        <p class="card-text">Considering a career in the trucking industry? Or are you a transportation company looking for trained drivers? Shelly Truck Driving School in York, PA provides 21st century training to future truck drivers.</p>
        <div className="p-2">
          <i class="bi bi-facebook p-2 fs-5"></i>
          <i class="bi bi-whatsapp p-2 fs-5"></i>
          <i class="bi bi-linkedin p-2 fs-5"></i>
          <i class="bi bi-youtube p-2 fs-5" ></i>
          </div>
      </div>
    </div>
  </div>
</div>

<div class="card mb-3 col-md-6" >
  <div class="row g-0">
    <div class="col-md-4">
      <img src="https://img.freepik.com/free-photo/young-handsome-man-with-beard-isolated-keeping-arms-crossed-frontal-position_1368-132662.jpg?size=626&ext=jpg&ga=GA1.2.320087390.1627862400" class="img-fluid rounded-start" alt="..."/>
    </div>
    <div class="col-md-8">
      <div class="card-body">
        <h5 class="card-title">Gerald S. Silver</h5>
        <p class="card-text">Considering a career in the trucking industry? Or are you a transportation company looking for trained drivers? Shelly Truck Driving School in York, PA provides 21st century training to future truck drivers.</p>
        <div className="p-2">
          <i class="bi bi-facebook p-2 fs-5"></i>
          <i class="bi bi-whatsapp p-2 fs-5"></i>
          <i class="bi bi-linkedin p-2 fs-5"></i>
          <i class="bi bi-youtube p-2 fs-5" ></i>
          </div>
      </div>
    </div>
  </div>
</div>

<div class="card mb-3 col-md-6" >
  <div class="row g-0">
    <div class="col-md-4">
      <img src="https://media.istockphoto.com/photos/portrait-of-smiling-handsome-man-in-blue-tshirt-standing-with-crossed-picture-id1045886560?k=20&m=1045886560&s=612x612&w=0&h=JL8Dy_sRUXJo6PofsX7XkQpWjSTDhD8LuV071LMlb3Y=" class="img-fluid rounded-start" alt="..."/>
    </div>
    <div class="col-md-8">
      <div class="card-body">
        <h5 class="card-title">John M. Ford</h5>
        <p class="card-text">Considering a career in the drivers? Or are you a transportation company looking for trained drivers? Shelly Truck Driving School in York, PA provides 21st century training to future  drivers.</p>
        <div className="p-2">
          <i class="bi bi-facebook p-2 fs-5"></i>
          <i class="bi bi-whatsapp p-2 fs-5"></i>
          <i class="bi bi-linkedin p-2 fs-5"></i>
          <i class="bi bi-youtube p-2 fs-5" ></i>
          </div>
      </div>
    </div>
  </div>
</div>
        </div>
        </div>
    );
};

export default About;